import * as core from '../../../../../../../core'

import { query } from './trends-table.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.trends.organization-trends-table',
    description:
      'Table showing trends in expenses broken down by department and PI over the last five years.',
    name: 'RP Trends - Organization Trends Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
